import { render, staticRenderFns } from "./projectinfo.vue?vue&type=template&id=b1860dcc&scoped=true&"
import script from "./projectinfo.vue?vue&type=script&lang=js&"
export * from "./projectinfo.vue?vue&type=script&lang=js&"
import style0 from "./projectinfo.vue?vue&type=style&index=0&id=b1860dcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1860dcc",
  null
  
)

export default component.exports